// Generated from api/openapi/agents.yaml by make docs. Do not edit.
import { z } from "zod";

export const anomalySchema = z.object({
  "id": z.string().uuid(),
  "successor_agent_id": z.string().uuid(),
  "predecessor_agent_id": z.string().uuid().optional(),
  "dimension_key": z.string(),
  "window_kind": z.enum(["rolling", "calendar_day", "calendar_month", "delegation_lifetime"]),
  "window_seconds": z.number().int().optional(),
  "cap_amount": z.number().int(),
  "predecessor_used": z.number().int(),
  "pct_of_cap": z.number(),
  "carried_forward": z.boolean(),
  "signature_kind": z.enum(["reprovision_resume", "sever_via_delete", "fresh_identity_suspected", "standing_delegation_reset"]),
  "confidence": z.enum(["high", "medium", "low"]),
  "detected_at": z.string().datetime({ offset: true }),
  "provenance": z.record(z.string(), z.unknown()).optional()
}).strict();

export const anomalyListResponseSchema = z.object({
  "anomalies": z.array(anomalySchema),
  "limit": z.number().int(),
  "offset": z.number().int()
}).strict();
